import LogService from "../../CommonSdk/LogService";

import * as ChannelService from "../../RainbowSdk/ChannelService";
import * as FileStorageService from "../../RainbowSdk/FileStorageService";

import * as ChannelActionTypes from "./ChannelActionTypes";
import * as ContactActions from "./ContactsActions";
import * as Utils from "../../Utils/ChannelUtils";
import * as AuthenticationUtils from "../../Utils/AuthenticationUtils";

//to test channel ID=6046269145d0b54da48edf5e on .net
//channel ID=5dfcf21894e80144c1777058 on .com
const LOG_TAG = "ACTIONS:CHANNEL";

const getCreator = (obj) => (dispatch) => {
    LogService.trace(LOG_TAG, "getCreator", "Get creator of the channel");

    let creatorId = obj.creatorId;
    dispatch(ContactActions.getContactDataById(creatorId));
}

const getPublisher = (items) => (dispatch) => {
    LogService.trace(LOG_TAG, "getPublisher", "Get publisher of the item channel");

    let jidList = [];
    if (items) {
        items.forEach(item => {
            if (jidList.indexOf(item.from) < 0) {
                jidList.push(item.from)
            }
        })
    }

    dispatch(ContactActions.getContactDataByJidList(jidList));
}

const getAllAttachmentsByChannel = () => (dispatch) => {
    LogService.trace(LOG_TAG, "getAllAttachmentsByChannel", "Get All files descriptor for item channel");

    dispatch({
        type: ChannelActionTypes.GET_ATTACHMENTS_CHANNEL_PROGRESS
    });

    let channelId = Utils.getChannelId();
    FileStorageService.getFileDescriptorByViewerId(channelId)
        .then(json => {
            LogService.trace(LOG_TAG, "getAllAttachmentsByChannel", "successfully received");
            dispatch({
                type: ChannelActionTypes.GET_ATTACHMENTS_CHANNEL_SUCCESS,
                payload: {
                    data: json
                }
            });
        })

        .catch(errorPayload => {
            LogService.warn(LOG_TAG, "Error", errorPayload);
            dispatch({
                type: ChannelActionTypes.GET_ATTACHMENTS_CHANNEL_ERROR,
                payload: errorPayload
            });
        })
}

const getImages = (items) => (dispatch) => {
    LogService.trace(LOG_TAG, "getImages", "Get images files include in item channel");

    dispatch({
        type: ChannelActionTypes.GET_IMAGES_PROGRESS
    });

    let fileIdList = [];
    if (items) {
        items.forEach((item) => {
            if (item.entry) {
                if (item.entry.images && typeof item.entry.images === "object") {//filter value "null"
                    if (item.entry.images instanceof Array) {
                        // for (let i = 0; i < item.entry.images.length; i++) {
                        //     fileIdList.push(item.entry.images[i]);
                        // }
                        fileIdList.push(...item.entry.images);
                    } else {
                        fileIdList.push(item.entry.images);
                    }
                }
            }
        });
    }

    FileStorageService.getFileDescriptorList(fileIdList)
        .then(json => {
            LogService.trace(LOG_TAG, "getImages", "successfully received");

            dispatch(getURLList(fileIdList))
            dispatch({
                type: ChannelActionTypes.GET_IMAGES_SUCCESS,
                payload: {
                    data: json
                }
            });
        })

        .catch(errorPayload => {
            LogService.warn(LOG_TAG, "Error", errorPayload);
            dispatch({
                type: ChannelActionTypes.GET_IMAGES_SUCCESS,
                payload: errorPayload
            });
        })
}

const getURLList = (fileIdList) => (dispatch) => {
    LogService.trace(LOG_TAG, "getURLList", "Get URL for item channel");

    dispatch({
        type: ChannelActionTypes.GET_URL_LIST_PROGRESS
    });

    FileStorageService.GetBackendTempURLList(fileIdList)
        .then(json => {
            LogService.trace(LOG_TAG, "getURLList", "successfully received url");

            dispatch({
                type: ChannelActionTypes.GET_URL_LIST_SUCCESS,
                payload: {
                    url: json
                }
            });

        })
        .catch(errorPayload => {
            LogService.warn(LOG_TAG, "Error", errorPayload);
            dispatch({
                type: ChannelActionTypes.GET_URL_LIST_ERROR,
                payload: errorPayload
            });
        })

}

const getAttachments = (items) => (dispatch) => {
    LogService.trace(LOG_TAG, "getAttachments", "Get files in the file storage for item channel");

    dispatch({
        type: ChannelActionTypes.GET_ATTACHMENTS_CHANNEL_PROGRESS
    });

    let fileIdList = [];
    if (items) {
        items.forEach((item) => {
            if (item.entry) {
                if (item.entry.attachments) {
                    if (item.entry.attachments.length !== undefined) {
                        for (let i = 0; i < item.entry.attachments.length; i++) {
                            fileIdList.push(item.entry.attachments[i]);
                        }
                    } else {
                        fileIdList.push(item.entry.attachments)
                    }
                }
            }
        });
    }

    FileStorageService.getFileDescriptorList(fileIdList)
        .then(json => {
            LogService.trace(LOG_TAG, "getAttachments", "successfully received");

            dispatch({
                type: ChannelActionTypes.GET_ATTACHMENTS_CHANNEL_SUCCESS,
                payload: {
                    data: json
                }
            });
        })

        .catch(errorPayload => {
            LogService.warn(LOG_TAG, "Error", errorPayload);
            dispatch({
                type: ChannelActionTypes.GET_ATTACHMENTS_CHANNEL_ERROR,
                payload: errorPayload
            });
        })
}

export const getInformationChannel = () => (dispatch, getState) => {

    LogService.trace(LOG_TAG, "getInformationChannel", "Get informations channel");

    const selectedServerUrl = AuthenticationUtils.getSelectedServerUrl(getState().authentication.account);
    const channelId = Utils.getChannelId(selectedServerUrl);
    if (channelId.length > 0) {
        dispatch({
            type: ChannelActionTypes.GET_INFORMATION_CHANNEL_PROGRESS
        });

        ChannelService.getInformationChannel(channelId)
            .then(json => {
                LogService.trace(LOG_TAG, "getInformationChannel", "successfully received");

                dispatch(getCreator(json.data));
                dispatch({
                    type: ChannelActionTypes.GET_INFORMATION_CHANNEL_SUCCESS,
                    payload: {
                        data: json.data
                    }
                });
            })

            .catch(errorPayload => {
                LogService.warn(LOG_TAG, "getInformationChannel", "error", errorPayload);

                dispatch({
                    type: ChannelActionTypes.GET_INFORMATION_CHANNEL_ERROR,
                    payload: errorPayload
                });
            });
    } else {
        LogService.warn(LOG_TAG, "getInformationChannel", "No channel id found");
    }
};

export const subscribeChannel = (callback, context) => (dispatch, getState) => {
    LogService.trace(LOG_TAG, "subscribeChannel", "Subscribe channel by id");

    dispatch({
        type: ChannelActionTypes.SUBSCRIBE_CHANNEL_PROGRESS
    });

    const channelId = getState().channel.data.id;
    ChannelService.subscribeChannel(channelId)
        .then(json => {
            LogService.trace(LOG_TAG, "subscribeChannel", "successfully received");
            dispatch({
                type: ChannelActionTypes.SUBSCRIBE_CHANNEL_SUCCESS,
                payload: {
                    status: json.status
                }
            });
            if (callback) callback.call(context);
        })
        .catch(errorPayload => {
            LogService.warn(LOG_TAG, "Error", errorPayload);
            dispatch({
                type: ChannelActionTypes.SUBSCRIBE_CHANNEL_ERROR,
                payload: errorPayload
            });
        })
};

export const unSubscribeChannel = (callback, context) => (dispatch, getState) => {
    LogService.trace(LOG_TAG, "unSubscribeChannel", "Unsubscribe channel by id");

    dispatch({
        type: ChannelActionTypes.UNSUBSCRIBE_CHANNEL_PROGRESS
    });

    const channelId = getState().channel.data.id;
    ChannelService.unSubscribeChannel(channelId)
        .then(json => {
            LogService.trace(LOG_TAG, "unSubscribeChannel", "successfully received");
            dispatch({
                type: ChannelActionTypes.UNSUBSCRIBE_CHANNEL_SUCCESS,
                payload: {
                    status: json.status
                }
            });
            if (callback) callback.call(context);
        })
        .catch(errorPayload => {
            LogService.warn(LOG_TAG, "Error", errorPayload);
            dispatch({
                type: ChannelActionTypes.UNSUBSCRIBE_CHANNEL_ERROR,
                payload: errorPayload
            });
        })
};

export const getItemsFromChannel = () => (dispatch, getState) => {
    LogService.trace(LOG_TAG, "getItemsFromChannel", "Get items from channel");

    dispatch({
        type: ChannelActionTypes.GET_ITEMS_CHANNEL_PROGRESS
    });

    const channelId = getState().channel.data.id;
    ChannelService.getItemsFromChannel(channelId)
        .then(json => {
            LogService.trace(LOG_TAG, "getItemsFromChannel", "successfully received");

            dispatch(getAttachments(json.data.items));
            dispatch(getImages(json.data.items))
            dispatch(getPublisher(json.data.items));
            dispatch({
                type: ChannelActionTypes.GET_ITEMS_CHANNEL_SUCCESS,
                payload: {
                    items: json.data.items,
                    status: json.data.status
                }
            });

        })
        .catch(errorPayload => {
            LogService.warn(LOG_TAG, "Error", errorPayload);
            dispatch({
                type: ChannelActionTypes.GET_ITEMS_CHANNEL_ERROR,
                payload: errorPayload
            });
        })
}

export const getUrlToDownloadFile = (fileId, callback, context) => (dispatch) => {
    LogService.trace(LOG_TAG, "getUrlToDownloadFile", "get URL attachments");

    dispatch({
        type: ChannelActionTypes.GET_URL_ATTACHMENTS_PROGRESS
    });

    FileStorageService.GetBackendTempURL(fileId)
        .then(json => {
            LogService.trace(LOG_TAG, "getAttachmentsURL", "successfully received url");
            dispatch({
                type: ChannelActionTypes.GET_URL_ATTACHMENTS_SUCCESS
            });
            if (callback) callback.call(context, json.url);
        })
        .catch(errorPayload => {
            LogService.warn(LOG_TAG, "Error", errorPayload);
            dispatch({
                type: ChannelActionTypes.GET_URL_ATTACHMENTS_ERROR,
                payload: errorPayload
            });
        })
};

export const clearChannel = () => (dispatch) => {
    dispatch({
        type: ChannelActionTypes.CLEAR_CHANNEL,
    });
};